// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SimilarStrollers__headline":"xi_a bhl_vp bhl_vh bhl_xe bhl_rg bhl_tr bhl_qx"};